import * as types from '../../actionTypes';

const initialState = {
    updateAppointmentsView: [],
    error: {},
    loading: false,
}



export  const updateAppointmentViewReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_APPOINTMENT_VIEW_LOADING:
            return {
                ...state,
                loading: true
            }
        case types.UPDATE_APPOINTMENT_VIEW_SUCCESS:
            console.log("actionddddd",action.payload)
            return {
                ...state,
                updateAppointmentsView: action.payload,
                loading: false,
                error: {}
            }
        case types.UPDATE_APPOINTMENT_VIEW_FAIL:
            return{
                ...state,
                error: action.payload,
                loading: false,
                updateAppointmentsView: []
            }
        
        default:
            return state;
    }
}